<div class="card-spacer">
    <div fxLayout="row" fxLayoutAlign="start center">
        <span style="margin-left: 8px; margin-top: 16px" class="mat-title mat-title-spacing">
            <mat-icon class="list-icon">dns</mat-icon>
            <span style=" margin-left: 8px">
                {{ data.title }}
            </span>
        </span>
        <span fxFlex></span>
        <span>
            <app-search-bar (searchFilter)="applyFilter($event)"></app-search-bar>
        </span>
    </div>
</div>
<mat-divider></mat-divider>
<div style="max-height: 500px; overflow-y: scroll;" class='table-responsive'>
    <mat-table matTableExporter #table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
        #exporter="matTableExporter">
        <ng-container *ngFor="let disCol of tableColumns; let colIndex = index" matColumnDef="{{disCol}}">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{disCol | titlecase}}</mat-header-cell>
            <mat-cell *matCellDef="let element "> {{element[disCol]}}
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: tableColumns;"></mat-row>
    </mat-table>
</div>
<div class="card-spacer">
    <mat-paginator [pageSizeOptions]="[10, 30, 100]"></mat-paginator>
</div>
<mat-divider></mat-divider>
<div style="margin-top: 24px" fxLayout="row" fxLayoutGap="16px">
    <button style="height: 40px; margin-right: 200px;" color="accent" mat-raised-button
        (click)="exporter.exportTable('xlsx', {fileName: data.title, sheet: 'sheet_name', Props: {Author: 'Supergroup IT'}})">Export</button>
    <span fxFlex></span>
    <button type="button" mat-flat-button (click)="cancel()">CLOSE</button>
</div>